const admin = {
  'admin-loading': 'Laden, bitte warten...',
  'geolocation-button': 'Geolokalisierung',
  'newsletter-button': 'Newsletter',
  'custom-modal-admin-button': 'Startseitenbild'
};

export default admin;
